export default __webpack_public_path__ + "static/media/ChainEffect.3c93ef9b.jpg";